 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import BUNDLE_COVER from '@/components/bundle_cover'
 import EBB from '@/components/ebb'
 import LOVE_1 from '@/components/love_1'
 import BUNDLE_TITLE from '@/components/bundle_title'
 import BUNDLE_CONTENT from '@/components/bundle_content'
 import BOOK1XHTMLCOVER from '@/components/Book1/xhtml/cover'
 import BOOK1XHTMLTITLE from '@/components/Book1/xhtml/title'
 import BOOK1XHTMLDEDICATION from '@/components/Book1/xhtml/dedication'
 import BOOK1XHTMLFRANTMATTER01 from '@/components/Book1/xhtml/frantmatter01'
 import BOOK1XHTMLFRANTMATTER02 from '@/components/Book1/xhtml/frantmatter02'
 import BOOK1XHTMLPART01 from '@/components/Book1/xhtml/part01'
 import BOOK1XHTMLCHAPTER01 from '@/components/Book1/xhtml/chapter01'
 import BOOK1XHTMLCHAPTER02 from '@/components/Book1/xhtml/chapter02'
 import BOOK1XHTMLCHAPTER03 from '@/components/Book1/xhtml/chapter03'
 import BOOK1XHTMLCHAPTER04 from '@/components/Book1/xhtml/chapter04'
 import BOOK1XHTMLCHAPTER05 from '@/components/Book1/xhtml/chapter05'
 import BOOK1XHTMLCHAPTER06 from '@/components/Book1/xhtml/chapter06'
 import BOOK1XHTMLCHAPTER07 from '@/components/Book1/xhtml/chapter07'
 import BOOK1XHTMLCHAPTER08 from '@/components/Book1/xhtml/chapter08'
 import BOOK1XHTMLCHAPTER09 from '@/components/Book1/xhtml/chapter09'
 import BOOK1XHTMLCHAPTER10 from '@/components/Book1/xhtml/chapter10'
 import BOOK1XHTMLCHAPTER11 from '@/components/Book1/xhtml/chapter11'
 import BOOK1XHTMLCHAPTER12 from '@/components/Book1/xhtml/chapter12'
 import BOOK1XHTMLCHAPTER13 from '@/components/Book1/xhtml/chapter13'
 import BOOK1XHTMLCHAPTER14 from '@/components/Book1/xhtml/chapter14'
 import BOOK1XHTMLCHAPTER15 from '@/components/Book1/xhtml/chapter15'
 import BOOK1XHTMLCHAPTER16 from '@/components/Book1/xhtml/chapter16'
 import BOOK1XHTMLCHAPTER17 from '@/components/Book1/xhtml/chapter17'
 import BOOK1XHTMLCHAPTER18 from '@/components/Book1/xhtml/chapter18'
 import BOOK1XHTMLCHAPTER19 from '@/components/Book1/xhtml/chapter19'
 import BOOK1XHTMLPART02 from '@/components/Book1/xhtml/part02'
 import BOOK1XHTMLCHAPTER20 from '@/components/Book1/xhtml/chapter20'
 import BOOK1XHTMLCHAPTER21 from '@/components/Book1/xhtml/chapter21'
 import BOOK1XHTMLCHAPTER22 from '@/components/Book1/xhtml/chapter22'
 import BOOK1XHTMLCHAPTER23 from '@/components/Book1/xhtml/chapter23'
 import BOOK1XHTMLCHAPTER24 from '@/components/Book1/xhtml/chapter24'
 import BOOK1XHTMLCHAPTER25 from '@/components/Book1/xhtml/chapter25'
 import BOOK1XHTMLCHAPTER26 from '@/components/Book1/xhtml/chapter26'
 import BOOK1XHTMLCHAPTER27 from '@/components/Book1/xhtml/chapter27'
 import BOOK1XHTMLCHAPTER28 from '@/components/Book1/xhtml/chapter28'
 import BOOK1XHTMLCHAPTER29 from '@/components/Book1/xhtml/chapter29'
 import BOOK1XHTMLCHAPTER30 from '@/components/Book1/xhtml/chapter30'
 import BOOK1XHTMLCHAPTER31 from '@/components/Book1/xhtml/chapter31'
 import BOOK1XHTMLCHAPTER32 from '@/components/Book1/xhtml/chapter32'
 import BOOK1XHTMLCHAPTER33 from '@/components/Book1/xhtml/chapter33'
 import BOOK1XHTMLCHAPTER34 from '@/components/Book1/xhtml/chapter34'
 import BOOK1XHTMLCHAPTER35 from '@/components/Book1/xhtml/chapter35'
 import BOOK1XHTMLPART03 from '@/components/Book1/xhtml/part03'
 import BOOK1XHTMLCHAPTER36 from '@/components/Book1/xhtml/chapter36'
 import BOOK1XHTMLCHAPTER37 from '@/components/Book1/xhtml/chapter37'
 import BOOK1XHTMLCHAPTER38 from '@/components/Book1/xhtml/chapter38'
 import BOOK1XHTMLCHAPTER39 from '@/components/Book1/xhtml/chapter39'
 import BOOK1XHTMLCHAPTER40 from '@/components/Book1/xhtml/chapter40'
 import BOOK1XHTMLCHAPTER41 from '@/components/Book1/xhtml/chapter41'
 import BOOK1XHTMLCHAPTER42 from '@/components/Book1/xhtml/chapter42'
 import BOOK1XHTMLCHAPTER43 from '@/components/Book1/xhtml/chapter43'
 import BOOK1XHTMLCHAPTER44 from '@/components/Book1/xhtml/chapter44'
 import BOOK1XHTMLCHAPTER45 from '@/components/Book1/xhtml/chapter45'
 import BOOK1XHTMLCHAPTER46 from '@/components/Book1/xhtml/chapter46'
 import BOOK1XHTMLCHAPTER47 from '@/components/Book1/xhtml/chapter47'
 import BOOK1XHTMLCHAPTER48 from '@/components/Book1/xhtml/chapter48'
 import BOOK1XHTMLCHAPTER49 from '@/components/Book1/xhtml/chapter49'
 import BOOK1XHTMLCHAPTER50 from '@/components/Book1/xhtml/chapter50'
 import BOOK1XHTMLCHAPTER51 from '@/components/Book1/xhtml/chapter51'
 import BOOK1XHTMLCHAPTER52 from '@/components/Book1/xhtml/chapter52'
 import BOOK21COVER from '@/components/Book2/1-cover'
 import BOOK22TITLE_PAGE from '@/components/Book2/2-title_page'
 import BOOK24DEDICATION from '@/components/Book2/4-dedication'
 import BOOK25CHAP1 from '@/components/Book2/5-chap1'
 import BOOK26CHAP2 from '@/components/Book2/6-chap2'
 import BOOK27CHAP3 from '@/components/Book2/7-chap3'
 import BOOK28CHAP4 from '@/components/Book2/8-chap4'
 import BOOK29CHAP5 from '@/components/Book2/9-chap5'
 import BOOK210CHAP6 from '@/components/Book2/10-chap6'
 import BOOK211CHAP7 from '@/components/Book2/11-chap7'
 import BOOK212CHAP8 from '@/components/Book2/12-chap8'
 import BOOK213CHAP9 from '@/components/Book2/13-chap9'
 import BOOK214CHAP10 from '@/components/Book2/14-chap10'
 import BOOK215CHAP11 from '@/components/Book2/15-chap11'
 import BOOK216CHAP12 from '@/components/Book2/16-chap12'
 import BOOK217CHAP13 from '@/components/Book2/17-chap13'
 import BOOK218CHAP14 from '@/components/Book2/18-chap14'
 import BOOK219CHAP15 from '@/components/Book2/19-chap15'
 import BOOK220CHAP16 from '@/components/Book2/20-chap16'
 import BOOK221CHAP17 from '@/components/Book2/21-chap17'
 import BOOK222CHAP18 from '@/components/Book2/22-chap18'
 import BOOK223CHAP19 from '@/components/Book2/23-chap19'
 import BOOK224CHAP20 from '@/components/Book2/24-chap20'
 import BOOK225CHAP21 from '@/components/Book2/25-chap21'
 import BOOK226CHAP22 from '@/components/Book2/26-chap22'
 import BOOK227CHAP23 from '@/components/Book2/27-chap23'
 import BOOK228CHAP24 from '@/components/Book2/28-chap24'
 import BOOK229CHAP25 from '@/components/Book2/29-chap25'
 import BOOK230CHAP26 from '@/components/Book2/30-chap26'
 import BOOK231CHAP27 from '@/components/Book2/31-chap27'
 import BOOK232CHAP28 from '@/components/Book2/32-chap28'
 import BOOK233CHAP29 from '@/components/Book2/33-chap29'
 import BOOK234CHAP30 from '@/components/Book2/34-chap30'
 import BOOK235CHAP31 from '@/components/Book2/35-chap31'
 import BOOK236CHAP32 from '@/components/Book2/36-chap32'
 import BOOK237CHAP33 from '@/components/Book2/37-chap33'
 import BOOK238CHAP34 from '@/components/Book2/38-chap34'
 import BOOK239CHAP35 from '@/components/Book2/39-chap35'
 import BOOK240CHAP36 from '@/components/Book2/40-chap36'
 import BOOK241CHAP37 from '@/components/Book2/41-chap37'
 import BOOK242CHAP38 from '@/components/Book2/42-chap38'
 import BOOK243CHAP39 from '@/components/Book2/43-chap39'
 import BOOK244CHAP40 from '@/components/Book2/44-chap40'
 import BOOK245CHAP41 from '@/components/Book2/45-chap41'
 import BOOK246CHAP42 from '@/components/Book2/46-chap42'
 import BOOK247CHAP43 from '@/components/Book2/47-chap43'
 import BOOK248CHAP44 from '@/components/Book2/48-chap44'
 import BOOK249CHAP45 from '@/components/Book2/49-chap45'
 import BOOK250CHAP46 from '@/components/Book2/50-chap46'
 import BOOK251CHAP47 from '@/components/Book2/51-chap47'
 import BOOK252CHAP48 from '@/components/Book2/52-chap48'
 import BOOK253CHAP49 from '@/components/Book2/53-chap49'
 import BOOK254CHAP50 from '@/components/Book2/54-chap50'
 import BOOK255CHAP51 from '@/components/Book2/55-chap51'
 import BOOK256CHAP52 from '@/components/Book2/56-chap52'
 import BOOK257CHAP53 from '@/components/Book2/57-chap53'
 import BOOK258CHAP54 from '@/components/Book2/58-chap54'
 import BOOK259CHAP55 from '@/components/Book2/59-chap55'
 import BOOK260CHAP56 from '@/components/Book2/60-chap56'
 import BOOK261CHAP57 from '@/components/Book2/61-chap57'
 import BOOK262CHAP58 from '@/components/Book2/62-chap58'
 import BOOK263CHAP59 from '@/components/Book2/63-chap59'
 import BOOK264CHAP60 from '@/components/Book2/64-chap60'
 import BOOK265CHAP61 from '@/components/Book2/65-chap61'
 import BOOK266CHAP62 from '@/components/Book2/66-chap62'
 import BOOK267CHAP63 from '@/components/Book2/67-chap63'
 import BOOK268CHAP64 from '@/components/Book2/68-chap64'
 import BOOK269CHAP65 from '@/components/Book2/69-chap65'
 import BOOK270CHAP66 from '@/components/Book2/70-chap66'
 import BOOK31COVER from '@/components/Book3/1-cover'
 import BOOK32TITLE_PAGE from '@/components/Book3/2-title_page'
 import BOOK33DEDICATION from '@/components/Book3/3-dedication'
 import BOOK35CHAP1 from '@/components/Book3/5-chap1'
 import BOOK36CHAP2 from '@/components/Book3/6-chap2'
 import BOOK37CHAP3 from '@/components/Book3/7-chap3'
 import BOOK38CHAP4 from '@/components/Book3/8-chap4'
 import BOOK39CHAP5 from '@/components/Book3/9-chap5'
 import BOOK310CHAP6 from '@/components/Book3/10-chap6'
 import BOOK311CHAP7 from '@/components/Book3/11-chap7'
 import BOOK312CHAP8 from '@/components/Book3/12-chap8'
 import BOOK313CHAP9 from '@/components/Book3/13-chap9'
 import BOOK314CHAP10 from '@/components/Book3/14-chap10'
 import BOOK315CHAP11 from '@/components/Book3/15-chap11'
 import BOOK316CHAP12 from '@/components/Book3/16-chap12'
 import BOOK317CHAP13 from '@/components/Book3/17-chap13'
 import BOOK318CHAP14 from '@/components/Book3/18-chap14'
 import BOOK319CHAP15 from '@/components/Book3/19-chap15'
 import BOOK320CHAP16 from '@/components/Book3/20-chap16'
 import BOOK321CHAP17 from '@/components/Book3/21-chap17'
 import BOOK322CHAP18 from '@/components/Book3/22-chap18'
 import BOOK323CHAP19 from '@/components/Book3/23-chap19'
 import BOOK324CHAP20 from '@/components/Book3/24-chap20'
 import BOOK325CHAP21 from '@/components/Book3/25-chap21'
 import BOOK326CHAP22 from '@/components/Book3/26-chap22'
 import BOOK327CHAP23 from '@/components/Book3/27-chap23'
 import BOOK328CHAP24 from '@/components/Book3/28-chap24'
 import BOOK329CHAP25 from '@/components/Book3/29-chap25'
 import BOOK330CHAP26 from '@/components/Book3/30-chap26'
 import BOOK331CHAP27 from '@/components/Book3/31-chap27'
 import BOOK332CHAP28 from '@/components/Book3/32-chap28'
 import BOOK333CHAP29 from '@/components/Book3/33-chap29'
 import BOOK334CHAP30 from '@/components/Book3/34-chap30'
 import BOOK335CHAP31 from '@/components/Book3/35-chap31'
 import BOOK336CHAP32 from '@/components/Book3/36-chap32'
 import BOOK337CHAP33 from '@/components/Book3/37-chap33'
 import BOOK338CHAP34 from '@/components/Book3/38-chap34'
 import BOOK339PUZZLE from '@/components/Book3/39-puzzle'
 import BOOK340CHAP35 from '@/components/Book3/40-chap35'
 import BOOK341PUZZLE from '@/components/Book3/41-puzzle'
 import BOOK342PUZZLE from '@/components/Book3/42-puzzle'
 import BOOK343CHAP36 from '@/components/Book3/43-chap36'
 import BOOK344PUZZLE from '@/components/Book3/44-puzzle'
 import BOOK345CHAP37 from '@/components/Book3/45-chap37'
 import BOOK346PUZZLE from '@/components/Book3/46-puzzle'
 import BOOK347PUZZLE from '@/components/Book3/47-puzzle'
 import BOOK348CHAP38 from '@/components/Book3/48-chap38'
 import BOOK349PUZZLE from '@/components/Book3/49-puzzle'
 import BOOK350PUZZLE from '@/components/Book3/50-puzzle'
 import BOOK351CHAP39 from '@/components/Book3/51-chap39'
 import BOOK352PUZZLE from '@/components/Book3/52-puzzle'
 import BOOK353PUZZLE from '@/components/Book3/53-puzzle'
 import BOOK354CHAP40 from '@/components/Book3/54-chap40'
 import BOOK355PUZZLE from '@/components/Book3/55-puzzle'
 import BOOK356PUZZLE from '@/components/Book3/56-puzzle'
 import BOOK357CHAP41 from '@/components/Book3/57-chap41'
 import BOOK358PUZZLE from '@/components/Book3/58-puzzle'
 import BOOK359PUZZLE from '@/components/Book3/59-puzzle'
 import BOOK360CHAP42 from '@/components/Book3/60-chap42'
 import BOOK361PUZZLE from '@/components/Book3/61-puzzle'
 import BOOK362CHAP43 from '@/components/Book3/62-chap43'
 import BOOK363PUZZLE from '@/components/Book3/63-puzzle'
 import BOOK364CHAP44 from '@/components/Book3/64-chap44'
 import BOOK365PUZZLE from '@/components/Book3/65-puzzle'
 import BOOK366CHAP45 from '@/components/Book3/66-chap45'
 import BOOK367PUZZLE from '@/components/Book3/67-puzzle'
 import BOOK368PUZZLE from '@/components/Book3/68-puzzle'
 import BOOK369CHAP46 from '@/components/Book3/69-chap46'
 import BOOK370CHAP47 from '@/components/Book3/70-chap47'
 import BOOK371CHAP48 from '@/components/Book3/71-chap48'
 import BOOK372CHAP49 from '@/components/Book3/72-chap49'
 import BOOK373CHAP50 from '@/components/Book3/73-chap50'
 import BOOK374CHAP51 from '@/components/Book3/74-chap51'
 import BOOK375CHAP52 from '@/components/Book3/75-chap52'
 import BOOK376CHAP53 from '@/components/Book3/76-chap53'
 import BOOK377CHAP54 from '@/components/Book3/77-chap54'
 import BOOK378CHAP55 from '@/components/Book3/78-chap55'
 import BOOK379CHAP56 from '@/components/Book3/79-chap56'
 import BOOK380CHAP57 from '@/components/Book3/80-chap57'
 import BOOK381CHAP58 from '@/components/Book3/81-chap58'
 import BOOK382CHAP59 from '@/components/Book3/82-chap59'
 import BOOK383CHAP60 from '@/components/Book3/83-chap60'
 import BOOK384CHAP61 from '@/components/Book3/84-chap61'
 import BOOK385CHAP62 from '@/components/Book3/85-chap62'
 import BOOK386CHAP63 from '@/components/Book3/86-chap63'
 import BOOK387CHAP64 from '@/components/Book3/87-chap64'
 import BOOK388CHAP65 from '@/components/Book3/88-chap65'
 import BOOK389CHAP66 from '@/components/Book3/89-chap66'
 import LOVE_2 from '@/components/love_2'
 import COMONENDMATTER01 from '@/components/Comon/endmatter01'
 import COMONCOPYRIGHT from '@/components/Comon/copyright'
 import COMONBACKAD_1 from '@/components/Comon/backad_1'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/bundle_content",
 			"name" : "bundle_content",
 			"component" : BUNDLE_CONTENT
 		},
 		{
 			"path" : "/Book1/xhtml/cover",
 			"name" : "Book1/xhtml/cover",
 			"component" : BOOK1XHTMLCOVER
 		},
 		{
 			"path" : "/Book1/xhtml/title",
 			"name" : "Book1/xhtml/title",
 			"component" : BOOK1XHTMLTITLE
 		},
 		{
 			"path" : "/Book1/xhtml/dedication",
 			"name" : "Book1/xhtml/dedication",
 			"component" : BOOK1XHTMLDEDICATION
 		},
 		{
 			"path" : "/Book1/xhtml/frantmatter01",
 			"name" : "Book1/xhtml/frantmatter01",
 			"component" : BOOK1XHTMLFRANTMATTER01
 		},
 		{
 			"path" : "/Book1/xhtml/frantmatter02",
 			"name" : "Book1/xhtml/frantmatter02",
 			"component" : BOOK1XHTMLFRANTMATTER02
 		},
 		{
 			"path" : "/Book1/xhtml/part01",
 			"name" : "Book1/xhtml/part01",
 			"component" : BOOK1XHTMLPART01
 		},
 		{
 			"path" : "/Book1/xhtml/chapter01",
 			"name" : "Book1/xhtml/chapter01",
 			"component" : BOOK1XHTMLCHAPTER01
 		},
 		{
 			"path" : "/Book1/xhtml/chapter02",
 			"name" : "Book1/xhtml/chapter02",
 			"component" : BOOK1XHTMLCHAPTER02
 		},
 		{
 			"path" : "/Book1/xhtml/chapter03",
 			"name" : "Book1/xhtml/chapter03",
 			"component" : BOOK1XHTMLCHAPTER03
 		},
 		{
 			"path" : "/Book1/xhtml/chapter04",
 			"name" : "Book1/xhtml/chapter04",
 			"component" : BOOK1XHTMLCHAPTER04
 		},
 		{
 			"path" : "/Book1/xhtml/chapter05",
 			"name" : "Book1/xhtml/chapter05",
 			"component" : BOOK1XHTMLCHAPTER05
 		},
 		{
 			"path" : "/Book1/xhtml/chapter06",
 			"name" : "Book1/xhtml/chapter06",
 			"component" : BOOK1XHTMLCHAPTER06
 		},
 		{
 			"path" : "/Book1/xhtml/chapter07",
 			"name" : "Book1/xhtml/chapter07",
 			"component" : BOOK1XHTMLCHAPTER07
 		},
 		{
 			"path" : "/Book1/xhtml/chapter08",
 			"name" : "Book1/xhtml/chapter08",
 			"component" : BOOK1XHTMLCHAPTER08
 		},
 		{
 			"path" : "/Book1/xhtml/chapter09",
 			"name" : "Book1/xhtml/chapter09",
 			"component" : BOOK1XHTMLCHAPTER09
 		},
 		{
 			"path" : "/Book1/xhtml/chapter10",
 			"name" : "Book1/xhtml/chapter10",
 			"component" : BOOK1XHTMLCHAPTER10
 		},
 		{
 			"path" : "/Book1/xhtml/chapter11",
 			"name" : "Book1/xhtml/chapter11",
 			"component" : BOOK1XHTMLCHAPTER11
 		},
 		{
 			"path" : "/Book1/xhtml/chapter12",
 			"name" : "Book1/xhtml/chapter12",
 			"component" : BOOK1XHTMLCHAPTER12
 		},
 		{
 			"path" : "/Book1/xhtml/chapter13",
 			"name" : "Book1/xhtml/chapter13",
 			"component" : BOOK1XHTMLCHAPTER13
 		},
 		{
 			"path" : "/Book1/xhtml/chapter14",
 			"name" : "Book1/xhtml/chapter14",
 			"component" : BOOK1XHTMLCHAPTER14
 		},
 		{
 			"path" : "/Book1/xhtml/chapter15",
 			"name" : "Book1/xhtml/chapter15",
 			"component" : BOOK1XHTMLCHAPTER15
 		},
 		{
 			"path" : "/Book1/xhtml/chapter16",
 			"name" : "Book1/xhtml/chapter16",
 			"component" : BOOK1XHTMLCHAPTER16
 		},
 		{
 			"path" : "/Book1/xhtml/chapter17",
 			"name" : "Book1/xhtml/chapter17",
 			"component" : BOOK1XHTMLCHAPTER17
 		},
 		{
 			"path" : "/Book1/xhtml/chapter18",
 			"name" : "Book1/xhtml/chapter18",
 			"component" : BOOK1XHTMLCHAPTER18
 		},
 		{
 			"path" : "/Book1/xhtml/chapter19",
 			"name" : "Book1/xhtml/chapter19",
 			"component" : BOOK1XHTMLCHAPTER19
 		},
 		{
 			"path" : "/Book1/xhtml/part02",
 			"name" : "Book1/xhtml/part02",
 			"component" : BOOK1XHTMLPART02
 		},
 		{
 			"path" : "/Book1/xhtml/chapter20",
 			"name" : "Book1/xhtml/chapter20",
 			"component" : BOOK1XHTMLCHAPTER20
 		},
 		{
 			"path" : "/Book1/xhtml/chapter21",
 			"name" : "Book1/xhtml/chapter21",
 			"component" : BOOK1XHTMLCHAPTER21
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js